function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * ResError represents a RES API error.
 */
var ResError =
/*#__PURE__*/
function () {
  function ResError(rid, method, params) {
    _classCallCheck(this, ResError);

    this.rid = rid;

    if (method) {
      this.method = method;
      this.params = params;
    }
  }

  _createClass(ResError, [{
    key: "__init",
    value: function __init(err) {
      this._code = err.code || 'system.unknownError';
      this._message = err.message || "Unknown error";
      this._data = err.data;
      return this;
    }
    /**
     * Error code
     * @type {string}
     */

  }, {
    key: "getResourceId",

    /**
     * Error resource ID
     * @returns {string} Resource ID
     */
    value: function getResourceId() {
      return this.rid;
    }
  }, {
    key: "code",
    get: function get() {
      return this._code;
    }
    /**
     * Error message
     * @type {string}
     */

  }, {
    key: "message",
    get: function get() {
      return this._message;
    }
    /**
     * Error data object
     * @type {*}
     */

  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }]);

  return ResError;
}();

export default ResError;